import React, { createContext } from 'react';

const QuestionContext = createContext({});
const QuestionsContext = createContext({});

export { QuestionContext, QuestionsContext };
